import { PROJECTS_REQUEST, PROJECTS_FETCH, PROJECTS_LIST, PROJECTS_EDIT, PROJECTS_FAIL, PROJECT_SET_SEARCH, PROJECTS_CLEAR,
	PROJECTS_COMPLETE, PROJECTS_GOALS, PROJECTS_EXPENSES, PROJECTS_PHASES_GROUPS, PROJECTS_PHASES_GROUPS_EDIT,
	PROJECTS_EMPLOYEES, PROJECTS_EMPLOYEES_EDIT, PROJECTS_EDIT_REQUEST, PROJECTS_COMMISSIONS, PROJECTS_FOLIOS} from "../store/config";

const projectsInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters: {
		q:'',
		type: '',
		modality_id: '',
		state_id: '',
		version_id: ''
	},
	options: [],
	project:{},
	goals:[],
	expenses: [],
	phases_groups: [],
	employees:{},
	roles: [],
	folios: [],
	edit: {
		isFetching: false
	},
	codes_assigned: false,
	version: {},
	permissions:[],
	search: undefined,
	error: undefined,
	message: undefined
};

const projects = (state=projectsInit, action) => {
	//console.log('action', action);
	switch (action.type){
		case PROJECTS_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case PROJECTS_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				timestamp: action.timestamp
			}
		case PROJECTS_LIST:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				timestamp: action.timestamp
			}
		case PROJECTS_EDIT:
			return {
				...state,
				project: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECTS_GOALS:
			return {
				...state,
				goals: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECTS_EXPENSES:
			return {
				...state,
				expenses: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECTS_COMMISSIONS:
			return {
				...state,
				isFetching: action.isFetching,
				project: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECTS_PHASES_GROUPS:
			return {
				...state,
				phases_groups: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECTS_PHASES_GROUPS_EDIT:
			return {
				...state,
				edit: {
					...state.edit,
					isFetching: action.isFetching,
					...action.payload
				},
				timestamp: action.timestamp
			}
		case PROJECTS_EMPLOYEES:
			return {
				...state,
				employees: action.payload,
				roles: action.roles,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECTS_EMPLOYEES_EDIT:
			return {
				...state,
				edit: {
					...state.edit,
					isFetching: action.isFetching,
					...action.payload
				},
				timestamp: action.timestamp
			}
		case PROJECT_SET_SEARCH:
			return {
				...state,
				search: action.search,
				timestamp: action.timestamp
			}
			/*
		case PROJECTS_DELETE:
			return{
				...state,
				message:'',
				data:action.responseData,
				timestamp:action.timestamp
			};
			*/

			/*
		case PROJECT_CHANGE_TAB_DATA:
			return {
				...state,
				currentTab: action.currentTab,
				timestamp: action.timestamp
			}
			*/
		case PROJECTS_EDIT_REQUEST:
			return {
				...state,
				edit: {
					...state.edit,
					isFetching: action.isFetching
				},
				timestamp: action.timestamp
			}
		case PROJECTS_FOLIOS:
			return {
				...state,
				isFetching: action.isFetching,
				folios: action.payload,
				codes_assigned: action.codes_assigned,
				version: action.version,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case PROJECTS_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case PROJECTS_CLEAR:
			return {
				...state,
				...action.payload,
				timestamp: action.timestamp
			}
		case PROJECTS_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				edit:{
					...state.edit,
					isFetching: action.isFetching,
				},
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return{
				...state
			}
	}
};

export default projects;



// WEBPACK FOOTER //
// ./src/reducers/projects.js